export default __webpack_public_path__ + "static/media/hht2_storybook_14.4db00332.png";